import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { useHistory } from 'react-router-dom';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import Union from '../../images/Union.png';
import UnionDark from '../../images/UnionDark.svg';
import { businessMapping } from '../../services/businessMapping';
import { VouchedStyles as classes } from './VouchedStyles';
import {
  CONTINUE,
  LIBRE_AHORRA_BUNDLE,
  SAVE,
  VOUCHED_MAIN_TEXT,
  VOUCHED_TEXT,
} from '../../constants';
import SaveAppContactInfo from '../SaveApp/SaveAppContactInfo';
import VouchedFailed from './VouchedFailed';
import { productNameURLMapping } from '../../services/productNameURLMapping';
import { productMapping } from '../../services/productMapping';
import { SaveAndContinue } from '../../images/svg/CustomizedSVG';

function VouchedSuccess() {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    idUploadStatus,
    productName,
    setAddress,
    location,
    language,
    flowInvitation,
    vouchedUploadCount,
    setVouchedUploadCount,
    isModalSaveLater,
    savedDataFlow,
    isApplicationSaved,
    setIsModalSaveLater,
    contactInformation,
    isLightTheme,
    theme,
    setCurrentPage,
    personalInformation,
    setPersonalInformation,
  } = useContext(LeadGenerationContext);

  useEffect(() => {
    setCurrentPage('vouched-success');
  }, []);

  const [isVerifying, setIsVerifying] = useState(false);

  const handleStartNow = () => {
    if (businessMapping(productName) && flowInvitation !== 'invitation-form') {
      setAddress(true);
    }

    if (idUploadStatus === true) {
      setVouchedUploadCount(vouchedUploadCount + 1);
    }
    setIsVerifying(true);
    setTimeout(() => {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/vouched`
      );
    }, 2000);
  };
  useEffect(() => {
    if (idUploadStatus === 'success') {
      history.push(
        `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
          productName
        )}/address-info`
      );
    } else if (idUploadStatus === 'failed') {
      if (productMapping(productName) === LIBRE_AHORRA_BUNDLE) {
        history.push(
          `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
            productName
          )}/vouched-failed`
        );
      }
    }
  }, [idUploadStatus, productName, location, language, history]);

  const handleOpenModal = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };

  return (
    <Box sx={{ ...classes.container, height: '100dvh', padding: 0 }}>
      <Box sx={classes.imageBox}>
        <Box
          component="img"
          src={isLightTheme ? Union : UnionDark}
          alt={t('Selfie illustration')}
          sx={classes.image}
        />
      </Box>

      <Box sx={classes.textBox}>
        <Typography
          sx={{
            ...classes.heading,
            color:
              theme?.palette?.mode === 'dark'
                ? theme?.palette?.primary?.main
                : theme?.palette?.errorSubtext?.main,
          }}
        >
          {t(VOUCHED_MAIN_TEXT, {
            defaultValue: VOUCHED_MAIN_TEXT,
          })}
        </Typography>
        <Typography
          sx={{
            ...classes.subtext,
            color:
              theme?.palette?.mode === 'dark'
                ? theme?.palette?.primary?.main
                : theme?.palette?.errorSubtext?.main,
          }}
        >
          {t(VOUCHED_TEXT, {
            defaultValue: VOUCHED_TEXT,
            nsSeparator: '|',
          })}
        </Typography>
      </Box>

      <Box sx={classes.buttonGroup}>
        {/* && !savedDataFlow && !isApplicationSaved */}
        {!isApplicationSaved && !savedDataFlow ? (
          <Button
            variant="outlined"
            onClick={handleOpenModal}
            color="orientalPrimary"
            sx={{
              ...classes.outlinedButton,
              border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
            }}
          >
            {t(SAVE, {
              defaultValue: SAVE,
            })}
          </Button>
        ) : (
          // </Grid>
          <IconButton
            disableFocusRipple
            // disabled={
            //   (currentPage === 'address-info' || currentPage === 'business-comp') &&
            //   disableContinue
            // }
            aria-label="saved icon"
            sx={{
              pointerEvents: 'none',
              paddingTop: '0px',
              '@media (max-width: 600px)': {
                paddingTop: '0px',
                minWidth: '48px',
              },
              '&:focus': {
                border: '1px solid #000',
                paddingBottom: 0,
                borderRadius: '3px',
              },
            }}
            // onClick={handleSaveApplication}
            // data-testid={saveApplicationTestId}
          >
            <SaveAndContinue color={theme?.palette?.orientalPrimary?.main} />
          </IconButton>
        )}
        <Button
          variant="contained"
          onClick={handleStartNow}
          disabled={isVerifying}
          color="primary"
          sx={{
            ...classes.containedButton,
            border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
            background: theme?.palette?.orientalPrimary?.main,
            '&:hover': {
              background: theme?.palette?.orientalPrimary?.main,
            },
          }}
        >
          {t(CONTINUE, {
            defaultValue: CONTINUE,
          })}
        </Button>
        {isModalSaveLater && (
          <SaveAppContactInfo openModal={isModalSaveLater} currentPage="vouched-success" />
        )}
      </Box>
    </Box>
  );
}

export default VouchedSuccess;
